import SmartCampaignResource from '@/modules/ta/smartcampaign/resources/SmartCampaignResource';
import SegmentService from '@/modules/core/app/services/SegmentService';
import {
  SmartCampaignCreate,
  SmartCampaignEdit,
} from '@/modules/ta/smartcampaign/smartcampaign.trackevents';
import { BaseFormService } from '@/modules/core/form/services/BaseFormService';

export class SmartCampaignFormService extends BaseFormService {
  constructor() {
    super(SmartCampaignResource);
  }

  /**
   * @param form
   */
  trackCreate(form) {
    SegmentService.track(SmartCampaignCreate.build(form.data));
  }

  /**
   * @param form
   */
  trackEdit(form) {
    SegmentService.track(SmartCampaignEdit.build(form.data));
  }
}

export default new SmartCampaignFormService();
